'use strict';

angular.module('AcaApp').directive('ngSearchAutocomplete', [
  'ParticipantService',
  function(ParticipantService){
    return {
      restrict: 'E',
      templateUrl: 'app/views/common/directives/search/searchAutocomplete.html',
      scope: {selectedItem: '=modelItem', preTin: '=preTin', subscriberTin: '=subscriberTin', includeSubscriber: '=includeSubscriber',isDisabled: '=isDisabled', coveredIndividuals: '=coveredIndividuals'},
      link: function($scope, element){
        $scope.searchCriteria = {};
        $scope.searchCriteria.type = 'account';
        $scope.searchCriteria.text = 'Account ID';
        $scope.searchCriteria.minLength = '3';
        if($scope.isDisabled === true){
          $scope.$$childHead.$mdAutocompleteCtrl.isDisabled = $scope.isDisabled;
        }
        $scope.querySearch = function(query, flagPreTin){
          var input = $(element).find('md-autocomplete input');
          if(!input.attr('maxlength')) {
            input.attr('maxlength', '20');
          }
          if($scope.searchCriteria.type === 'tin' && query.length >= 9){
            return ParticipantService.searchParticipantsByTin(query + '%').then(function(data){
              var arrayExtaInfo = data.result.filter(function(e){
                if(!$scope.coveredIndividuals) return true;
                return !$scope.coveredIndividuals.some(function(ci){
                  if(!ci.data) return false;
                  return ci.data.tin === e.tin;
                });
              })
              .filter(function(ci){
                return ($scope.includeSubscriber || ci.tin !== $scope.subscriberTin);
              })
              .map(function(employee){
                var middlename = (employee.middlename !== undefined) ? ' ' + employee.middlename : '';
                var name2 = (employee.name2 !== undefined) ? ' ' + employee.name2 : '';
                employee.tinWithoutSuffix = ParticipantService.removeSuffixOnTin(employee.tin);
                employee.description = employee.accountno ? 'Acct # ' + employee.accountno + ' ' : '';
                employee.description += employee.name + middlename + name2 + ' SSN # ' + employee.tin;
                if(employee.description.length >=35){
                  employee.description = employee.description.substring(0, 32);
                  employee.description += '...';
                }
                return employee;
              });
              if(arrayExtaInfo.length > 0){
                if(flagPreTin) {
                  var dataEmployee = {
                    description: arrayExtaInfo[0].description,
                    tin: arrayExtaInfo[0].tin,
                    accountno: arrayExtaInfo[0].accountno,
                    name: arrayExtaInfo[0].name,
                    middlename: arrayExtaInfo[0].middlename,
                    name2: arrayExtaInfo[0].name2
                  };
                  $scope.selectedItem = dataEmployee;
                }
                return arrayExtaInfo;
              }
              else{
                return $scope.selectedItem;
              }
            }, function(error){
              console.log('Error', error);
            });
          }
          if($scope.searchCriteria.type === 'account' && query.length >= 6){
            return ParticipantService.searchParticipantsByAccount(query).then(function(data){
              return data.result.filter(function(e){
                if(!$scope.coveredIndividuals) return true;
                return !$scope.coveredIndividuals.some(function(ci){
                  if(!ci.data) return false;
                  return ci.data.tin === e.tin;
                });
              })
              .filter(function(ci){
                return ($scope.includeSubscriber || ci.tin !== $scope.subscriberTin);
              })
              .map(function(employee){
                var middlename = (employee.middlename !== undefined) ? ' ' + employee.middlename : '';
                var name2 = (employee.name2 !== undefined) ? ' ' + employee.name2 : '';
                employee.tinWithoutSuffix = ParticipantService.removeSuffixOnTin(employee.tin);
                employee.description = employee.accountno ? 'Acct # ' + employee.accountno + ' ' : '';
                employee.description += employee.name + middlename + name2 + ' SSN # ' + employee.tin;
                if(employee.description.length >=35){
                  employee.description = employee.description.substring(0, 32);
                  employee.description += '...';
                }
                return employee;
              });
            }, function(error){
              console.log('Error', error);
            });
          }
        };

        $scope.searchTextChange = function(selectedItem){
          var status = selectedItem ? true : false;
          $(element).find('md-autocomplete input').prop('disabled', status);
        };

        $scope.toogleSearchOptions = function(event){
          event.stopPropagation();
          $(element).find('.search-options-menu').fadeToggle('fast');
        };

        $scope.changeSearchCriteria = function(criteria){
          if(criteria !== $scope.searchCriteria.type){
            var el = $(element).find('md-autocomplete input');
            $scope.searchCriteria.type = criteria;
            el.prop('disabled', false);
            $scope.searchText = '';
            switch(criteria){
              case 'account':
                $scope.searchCriteria.text = 'Account ID';
                $scope.searchCriteria.minLength = '3';
                el.attr('maxlength', '20');
              break;
              case 'tin':
                $scope.searchCriteria.text = 'SSN';
                $scope.searchCriteria.minLength = '9';
                el.attr('maxlength', '14');
              break;
            }
          }
        };

        if($scope.preTin !== undefined){
          $scope.changeSearchCriteria('tin');
          $scope.querySearch($scope.preTin, true);
        }
      }
    };
  }
]);
